import React from 'react';
import { PERMISSION } from 'pages/CustomerWorking/utils/constants';

const CustomerWorking = React.lazy(() => import('pages/CustomerWorking/pages/CustomerWorking'));
const CustomerWorkingAdd = React.lazy(() => import('pages/CustomerWorking/pages/CustomerWorkingAdd'));
const CustomerWorkingEdit = React.lazy(() => import('pages/CustomerWorking/pages/CustomerWorkingEdit'));
const CustomerWorkingDetail = React.lazy(() => import('pages/CustomerWorking/pages/CustomerWorkingDetail'));

const customerWorkingRoute = [
  {
    path: '/customer-working',
    exact: true,
    name: 'Danh sách công việc CSKH',
    function: PERMISSION.VIEW,
    component: CustomerWorking,
  },
  {
    path: '/care-task',
    exact: true,
    name: 'Danh sách công việc CSKH',
    function: PERMISSION.VIEW,
    component: CustomerWorking,
  },
  {
    path: '/care-task/add',
    exact: true,
    name: 'Thêm mới công việc CSKH',
    function: PERMISSION.ADD,
    component: CustomerWorkingAdd,
  },
  {
    path: '/customer-working/add',
    exact: true,
    name: 'Thêm mới công việc CSKH',
    function: PERMISSION.ADD,
    component: CustomerWorkingAdd,
  },
  {
    path: '/care-task/edit/:customer_working_id',
    exact: true,
    name: 'Chỉnh sửa công việc CSKH',
    function: PERMISSION.EDIT,
    component: CustomerWorkingEdit,
  },
  {
    path: '/customer-working/edit/:customer_working_id',
    exact: true,
    name: 'Chỉnh sửa công việc CSKH',
    function: PERMISSION.EDIT,
    component: CustomerWorkingEdit,
  },
  {
    path: '/care-task/detail/:customer_working_id',
    exact: true,
    name: 'Chi tiết công việc CSKH',
    function: PERMISSION.VIEW,
    component: CustomerWorkingDetail,
  },
  {
    path: '/customer-working/detail/:customer_working_id',
    exact: true,
    name: 'Chi tiết công việc CSKH',
    function: PERMISSION.VIEW,
    component: CustomerWorkingDetail,
  },
];

export default customerWorkingRoute;
